import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import { FadedPaper } from '../../theme/StyledFields';
import KeyTakeaway from '../team-report/KeyTakeaway';
import { PreAssessmentCompletionSection as PreAssessmentData } from './types';

interface Props {
    data: PreAssessmentData;
    totalOrganizationAthletes: number;
}

const PreAssessmentCompletionSection: React.FC<Props> = ({ data, totalOrganizationAthletes }) => (
    <FadedPaper sx={{ p: 3, mb: 3 }} data-testid="section-pre-assessment-completion">
        <Typography variant="h5" sx={{ mb: 1 }}>
            Pre-assessment completion
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Share of roster athletes in this organization who have submitted their initial pre-assessment
            for their assigned program assessment.
        </Typography>
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Roster athletes</TableCell>
                        <TableCell align="right">Completed initial pre-assessment</TableCell>
                        <TableCell align="right">%</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>{totalOrganizationAthletes}</TableCell>
                        <TableCell align="right">{data.completed_count}</TableCell>
                        <TableCell align="right">{data.percent}%</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        <KeyTakeaway text={data.key_takeaway} />
    </FadedPaper>
);

export default PreAssessmentCompletionSection;
